import { render } from "./Folder.vue?vue&type=template&id=1ec29ff6&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=1ec29ff6&scoped=true&lang=css"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec29ff6"],['__file',"backend/vue/components/Folder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ec29ff6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ec29ff6', __exports__)) {
    api.reload('1ec29ff6', __exports__)
  }
  
  module.hot.accept("./Folder.vue?vue&type=template&id=1ec29ff6&scoped=true", () => {
    api.rerender('1ec29ff6', render)
  })

}


export default __exports__